import { html } from 'diagram-js/lib/ui'
import './styles.css'

function highlightFeel(input) {
  const escaped = (str) => str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

  const regex = /(".*?"|\b\d+(\.\d+)?\b|\b(true|false|null)\b|\bnow\(\)|[=()+\-*/])/gi

  return escaped(input).replace(regex, (match) => {
    if (/^".*"$/.test(match)) return `<span class="feel-token-string">${match}</span>`
    if (/^\d/.test(match)) return `<span class="feel-token-number">${match}</span>`
    if (/^(true|false|null)$/.test(match)) return `<span class="feel-token-boolean">${match}</span>`
    if (/^now\(\)$/.test(match)) return `<span class="feel-token-function">${match}</span>`
    if (/^[=()+\-*/]$/.test(match)) return `<span class="feel-token-operator">${match}</span>`
    return match
  })
}

export default function UrlEntryHTM(props) {
  const { id, getValue, onChange } = props
  // const [isFeelActive, setIsFeelActive] = useState(false)
  const isFeelActive = false

  const value = getValue('url')() || ''

  const handleChange = (event) => {
    const newValue = event.target.value
    onChange('url')(newValue)
  }

  // const toggleFeel = () => setIsFeelActive((prev) => !prev)

  return html`
    <div data-entry-id="searchableSelect-url" class="bio-properties-panel-feel-templating bio-properties-panel-entry">
      <div class=${'bio-properties-panel-feel-entry' + (isFeelActive ? ' feel-active' : '')}>
        <label for="${id}" class="bio-properties-panel-label">
          URL
          <button
            type="button"
            title=${isFeelActive
              ? 'Click to remove dynamic value with FEEL expression'
              : 'Click to set a dynamic value with FEEL expression'}
            class=${'bio-properties-panel-feel-icon optional' + (isFeelActive ? ' active' : '')}
          >
            <!-- Your SVG icon here -->
            <svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M3.617 11.99c-.137.684-.392 1.19-.765 1.518-.362.328-.882.492-1.558.492H0l.309-1.579h1.264l1.515-7.64h-.912l.309-1.579h.911l.236-1.191c.137-.685.387-1.192.75-1.52C4.753.164 5.277 0 5.953 0h1.294L6.94 1.579H5.675l-.323 1.623h1.264l-.309 1.579H5.043l-1.426 7.208ZM5.605 11.021l3.029-4.155L7.28 3.202h2.073l.706 2.547h.176l1.691-2.547H14l-3.014 4.051 1.338 3.768H10.25l-.706-2.606H9.37L7.678 11.02H5.605Z"
                fill="currentcolor"
              />
            </svg>
          </button>
        </label>

        <div class="bio-properties-panel-feel-container">
          ${isFeelActive
            ? html`
                <span class="bio-properties-panel-feel-indicator">=</span>
                <div class="bio-properties-panel-feel-editor-container">
                  <div class="bio-properties-panel-feel-editor__open-popup-placeholder">Opened in editor</div>
                  <div name="${id}" class="bio-properties-panel-input edited">
                    <div class="cm-editor">
                      <div class="cm-announced" aria-live="polite"></div>
                      <div tabindex="-1" class="cm-scroller">
                        <div
                          spellcheck="false"
                          autocorrect="off"
                          autocapitalize="off"
                          translate="no"
                          contenteditable="true"
                          style="tab-size: 4;"
                          class="cm-content cm-lineWrapping"
                          role="textbox"
                          aria-multiline="true"
                          id="${id}"
                          aria-label="URL"
                          data-language="FEEL expression"
                          aria-autocomplete="list"
                        >
                          <div class="cm-line" dangerouslySetInnerHTML=${{ __html: highlightFeel(value || '') }}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button type="button" title="Open pop-up editor" class="bio-properties-panel-open-feel-popup">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 32 32">
                      <path
                        fill="currentColor"
                        d="M28 4H10a2.006 2.006 0 0 0-2 2v14a2.006 2.006 0 0 0 2 2h18a2.006 2.006 0 0 0 2-2V6a2.006 2.006 0 0 0-2-2Zm0 16H10V6h18Z"
                      />
                      <path
                        fill="currentColor"
                        d="M18 26H4V16h2v-2H4a2.006 2.006 0 0 0-2 2v10a2.006 2.006 0 0 0 2 2h14a2.006 2.006 0 0 0 2-2v-2h-2Z"
                      />
                    </svg>
                  </button>
                </div>
              `
            : html`
                <div class="bio-properties-panel-feelers-editor-container">
                  <input
                    class="bio-properties-panel-input"
                    id="${id}"
                    type="text"
                    value=${value}
                    onInput=${handleChange}
                  />
                  <button type="button" title="Open pop-up editor" class="bio-properties-panel-open-feel-popup">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 32 32">
                      <path
                        fill="currentColor"
                        d="M28 4H10a2.006 2.006 0 0 0-2 2v14a2.006 2.006 0 0 0 2 2h18a2.006 2.006 0 0 0 2-2V6a2.006 2.006 0 0 0-2-2Zm0 16H10V6h18Z"
                      />
                      <path
                        fill="currentColor"
                        d="M18 26H4V16h2v-2H4a2.006 2.006 0 0 0-2 2v10a2.006 2.006 0 0 0 2 2h14a2.006 2.006 0 0 0 2-2v-2h-2Z"
                      />
                    </svg>
                  </button>
                </div>
              `}
        </div>
      </div>
    </div>
  `
}
